import { UseFormRegister } from "react-hook-form";
import { TimeFrame } from "@/redux/slices/business/types";
import { clsx } from "@/utils";
import { Typography } from "..";

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface TimeFrameInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  timeName: string;
  timeFrameName: string;
  register: UseFormRegister<any>;
  options: TimeFrame[];
  error?: string;
  inputSize?: "sm" | "md" | "lg";
}

export const TimeFrameInput = (timeFrameInputProps: TimeFrameInputProps) => {
  const { timeName, timeFrameName, register, options, error, className, disabled, inputSize = "lg", ...props } = timeFrameInputProps;

  const sizeClass = {
    "h-[32px]": inputSize === "sm",
    "h-[38px]": inputSize === "md",
    "h-12": inputSize === "lg",
  };

  return (
    <div className="flex flex-row items-center gap-3">
      <div className={clsx("flex focus-within:z-10", className)}>
        <select
          className={clsx(
            "w-[90px] cursor-pointer rounded-l-lg border border-r-0 border-neutral-mid-gray bg-neutral-gray pl-3 text-sm font-medium text-neutral-dark-gray focus:border-neutral-mid-gray focus:ring-0",
            sizeClass
          )}
          disabled={disabled}
          {...register(timeFrameName)}
        >
          {options.map((opt) => {
            const labels: Record<string, string> = { minute: "Min", hour: "Hour", day: "Day" };
            return labels[opt] ? <option key={opt} value={opt}>{labels[opt]}</option> : null;
          })}
        </select>
        <input
          type="number"
          className={clsx(
            "block w-full rounded-r-lg px-4 text-base placeholder-neutral-dark-gray focus:border-primary focus:ring-0 disabled:cursor-not-allowed disabled:bg-neutral-surface-gray",
            sizeClass,
            error ? "border-danger text-danger" : "border-neutral-mid-gray text-neutral-black"
          )}
          disabled={disabled}
          step="1"
          {...register(timeName)}
          {...props}
        />
      </div>
      {error && (
        <Typography variant="paragraph" className="text-danger">
          {error}
        </Typography>
      )}
    </div>
  );
};

TimeFrameInput.displayName = "TimeFrameInput";
